import type React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const HeaderLogoPart: React.FC = () => {
  return (
    <div className="flex-shrink-0 flex items-center h-full">
      <div className="lg:hidden h-full flex items-center">
        <Link href="/">
          <div className="relative h-8 w-8">
            <Image fill src="/images/logo_mark.svg" alt="LingualBox" />
          </div>
        </Link>
      </div>
      <div
        className="hidden lg:flex lg:items-center"
        style={{ height: '64px', lineHeight: '64px' }}
      >
        <Link href="/">
          <div
            className="relative"
            style={{ width: '130px', height: '28.5px' }}
          >
            <Image fill src="/images/logo_color.svg" alt="LingualBox" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default HeaderLogoPart;
